module.exports = __webpack_public_path__ + "assets/img/2.f644aecc.jpg";